import { useEffect, useRef, useCallback } from 'react';

export const useAutoScroll = <T extends HTMLElement>(
  ref: React.RefObject<T>,
  deps: any[] = []
) => {
  // Flaga, czy scroll jest włączony
  const shouldScrollRef = useRef(true);

  // Funkcja scrollująca do dołu
  const scrollToBottom = useCallback(() => {
    if (ref.current && shouldScrollRef.current) {
      ref.current.scrollTop = ref.current.scrollHeight;
    }
  }, [ref]);

  // Efekt autoscroll przy zmianie danych
  useEffect(() => {
    scrollToBottom();
  }, [...deps, scrollToBottom]);

  // Detekcja scrolla użytkownika
  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const onScroll = () => {
      // Jeśli użytkownik jest powyżej dolnej części, wyłącz autoscroll
      const isAtBottom =
        element.scrollHeight - element.scrollTop - element.clientHeight < 50; // 50px tolerancji
      shouldScrollRef.current = isAtBottom;
    };

    element.addEventListener('scroll', onScroll);
    return () => {
      element.removeEventListener('scroll', onScroll);
    };
  }, [ref]);

  // Funkcja ręcznego wymuszenia scrolla do dołu
  const scrollManuallyToBottom = useCallback(() => {
    shouldScrollRef.current = true;
    scrollToBottom();
  }, [scrollToBottom]);

  return { scrollToBottom: scrollManuallyToBottom };
};
